export const SEARCH_NAMES = {
  SORT_BY: "orderBy",
  SORT_ORDER: "orderSort",
  SEARCH_TEXT: "searchText",
  DATUM: "datum",
  DATUM_RANGE_TYPE: "datumRangeType",
  DATUM_SECOND_RANGE: "datumSecondRange",
  SKIP: "skip",
  LIMIT: "limit",
};

export const SEARCH_RANGES = {
  START: { value: "start", label: "od" },
  END: { value: "end", label: "do" },
  START_END: { value: "start_end", label: "od-do" },
  ALL: { value: "", label: "svi" },
};

export const SEARCH_SORT = {
  DATUM: { value: "datum", label: "datum" },
  ASC: { value: 1, label: "rastuce" },
  DESC: { value: -1, label: "opadajuce" },
};

export const SEARCH_NO_LIMIT = "SEARCH_NO_LIMIT";
